import type { Epic } from '../../index.js'
import { Actions } from '../../Slice/index.js'
import { visualizationSlice } from '../../Slice/Visualization/VisualizationSlice.js'
import { catchError, EMPTY, filter, map, mergeMap, of } from 'rxjs'
import { withLatestFrom } from 'rxjs/operators'
import { selectSavableVizState } from '../../../View/Component/ConfigurableVisualization/Persistence/SavedViz.js'
import { createWorkspaceState } from '../../../Repository/Visualization/WorkspaceStates.js'

export const createRemoteViewEpic: Epic = (action$, state$) => {
  const v = Actions[visualizationSlice.name]
  return action$.pipe(
    filter(v.remoteCreateRequest.match),
    withLatestFrom(state$),
    mergeMap(([action, s]) => {
      const scope = s.visualization.scope
      if (!scope) return EMPTY

      const savedViz = selectSavableVizState(s.visualization)
      const body = {
        projectId: scope.kind === 'project' ? scope.id : null,
        orderId: scope.kind === 'order' ? scope.id : null,
        name: action.payload.name,
        comment: action.payload.comment,
        isTemplate: action.payload.isTemplate,
        isShared: action.payload.shared,
        schemaVersion: 'viz-v1',
        state: savedViz
      }

      return createWorkspaceState(body).pipe(
        map((created) =>
          v.remoteCreateSuccess({
            item: {
              id: created.id,
              name: created.name,
              comment: created.comment,
              isTemplate: created.isTemplate,
              isShared: created.isShared,
              schemaVersion: created.schemaVersion,
              createdAt: created.createdAt,
              modifiedAt: created.modifiedAt,
              lastUsedAt: created.lastUsedAt
            }
          })
        ),
        catchError((e) => of(v.remoteCreateFailure({ error: String(e) })))
      )
    })
  )
}
